const $$splitComponentImporter = () => import('/app/src/routes/dashboard/supervisor/credit.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/supervisor/credit")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});